<app-modal [open]="active" [name]="'welcome'" (close)="closeDialog()">
  <div modal-header>
    {{
      user.firstName
        ? "Welcome to CONNECT, " + user.firstName + "!"
        : "Welcome to CONNECT!"
    }}
  </div>
  <div modal-body>
    <p>Welcome to CONNECT!</p>

    <p>
      We're excited to have you on board. To get started, please complete
      your profile, supported services, and service zones in the "My
      Account" section. This will help us better understand your
      capabilities and ensure smooth collaboration.
    </p>

    <p>Thank you for joining us!</p>
    <p>
      Best regards, <br />
      The CONNECT Team
    </p>
  </div>
  <button
    modal-footer
    type="button"
    class="btn btn--secondary"
    data-testid="welcome-close"
    (click)="closeDialog()"
  >
    Close
  </button>
</app-modal>
